/**
 * Расчёт суммы «после НДС». Формула совпадает с backend: utils.vat_calculations.amount_after_vat
 * См. docs/guides/CALCULATIONS.md
 * @param {number|null} amountBefore - сумма до НДС
 * @param {number} vatPct - процент НДС (например 5)
 * @returns {number|null}
 */
export function amountAfterVat(amountBefore, vatPct) {
  if (amountBefore == null) return null
  if (Number(amountBefore) === 0) return 0
  const x = Number(amountBefore)
  const y = Number(vatPct) || 0
  return Math.round((x - (x * y / (100 + y))) * 100) / 100
}
